export default "__VITE_ASSET__DOfYH$C9__"